import type { SVGProps } from 'react';
const SvgQuickreply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#quickreply_svg__a)">
      <path d="M22 4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-8h7V4Z" />
      <path d="M22.5 16h-2.2l1.7-4h-5v6h2v5l3.5-7Z" />
    </g>
    <defs>
      <clipPath id="quickreply_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgQuickreply;
